export class TranscriptChunk {
  public id: number;
  public title: string;
  public transcriptDate: Date;
  public chunkId?: number;
  public content?: string;

  constructor(transcriptChunk: any) {
    this.id = transcriptChunk.transcriptId;
    this.title = transcriptChunk.title;
    this.transcriptDate = new Date(transcriptChunk.transcriptDate);
    this.chunkId = transcriptChunk.chunkId;
    this.content = transcriptChunk.content;
  }
}
